export default "__VITE_ASSET__B1h72ACs__"